import { render, staticRenderFns } from "./Cubagem.vue?vue&type=template&id=c46822ba&scoped=true"
import script from "./Cubagem.vue?vue&type=script&lang=js"
export * from "./Cubagem.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=c46822ba&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46822ba",
  null
  
)

export default component.exports